import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-body',
  templateUrl: './body.component.html',
  styleUrls: []
})
export class BodyComponent implements OnInit {

  constructor(private router: Router) { 
    if (!window.localStorage.getItem(btoa('access_token')) || window.localStorage.getItem(btoa('access_token'))=='null' || window.localStorage.getItem(btoa('access_token'))==null) {
      this.router.navigate(['./login']);
    }
  }

  ngOnInit() {
  }

}
